export const faqs = [
  {
    question: "Ist der Kurs für mich geeignet?",
    answer: "Unsere Kurse sind für Anfänger bis Fortgeschrittene aufgebaut. Durch die klare Struktur und die persönliche Betreuung findest du auch ohne Vorkenntnisse gut rein. Wenn du unsicher bist, helfen wir dir bei der Einstufung."
  },

  {
    question: "Wie läuft der Live-Unterricht ab?",
    answer: "Unsere Live-Kurse finden online über eine leicht verständliche Plattform statt – du brauchst nur Internet und ein Gerät. Du lernst in kleinen Gruppen direkt mit dem Lehrer und anderen Schülern, kannst jederzeit Fragen stellen und bekommst direkt Feedback. Jede Sitzung dauert je nach Kurs in der Regel 60 Minuten und besteht aus Erklärungen, interaktiven Übungen, Gesprächen und praktischen Beispielen."
  },

  {
    question: "Wie oft findet der Unterricht statt?",
    answer: "Der Unterricht findet in der Regel zweimal pro Woche live statt. Jede Einheit dauert je nach Kurs etwa 60 Minuten."
  },

  {
    question: "Wie läuft die Anmeldung ab?",
    answer: "Du füllst zuerst das Online-Formular aus und wählst deinen gewünschten Kurs aus. Danach melden wir uns persönlich bei dir, besprechen dein Niveau und klären offene Fragen. Sobald alles passt, erhältst du alle weiteren Informationen und kannst mit deinem Kurs starten."
  },

  {
    question: "Wie läuft die Bezahlung ab?",
    answer: "Die Bezahlung erfolgt je nach Kurs entweder in monatlichen Raten über die Kursdauer oder als Einmalzahlung. Nach deiner Anmeldung erhältst du alle weiteren Informationen zur Zahlung. Sobald alles geklärt ist, kann dein Kursstart vorbereitet werden."
  },

  {
    question: "Was unterscheidet Arabicroots von anderen Kursen?",
    answer: "Wir wissen aus eigener Erfahrung, wie schwer es sein kann, Arabisch zu lernen – besonders wenn man gleichzeitig mit den Herausforderungen des Alltags kämpft. Genau deshalb haben wir Arabicroots gegründet: Unser Ziel ist es, Arabisch verständlich und alltagsnah auf Deutsch zu vermitteln – ohne Druck, aber mit klarer Struktur und echter Unterstützung. Unsere Kurse finden bewusst in kleinen Gruppen statt, damit du nicht untergehst, sondern wirklich gesehen wirst. Du sprichst aktiv im Unterricht, hast direkten Kontakt zu deinem Lehrer und lernst gemeinsam mit anderen motivierten Schülern. Und falls du einmal nicht live dabei sein kannst, stehen dir hochwertige Aufzeichnungen zur Verfügung, damit du flexibel bleibst und nichts verpasst. Bei uns bist du keine Nummer – du bist Teil einer echten Lernreise."
  },

  {
    question: "Welches Arabisch lernen wir?",
    answer: "In unseren Kursen lernst du Hocharabisch (Fuṣḥā) – die Standardsprache, die in der gesamten arabischen Welt verstanden, gelesen und geschrieben wird. Sie ist die Sprache des Qurʾān, der Medien, der Literatur und des Bildungsbereichs."
  },

  {
    question: "Wie viele Schüler sind in einem Kurs?",
    answer: "Unsere Gruppen sind bewusst klein gehalten – meist mit etwa 3 bis 8 aktiven Teilnehmern. So bekommst du mehr Raum zum Sprechen, individuelles Feedback und echte persönliche Betreuung. Du lernst in einer angenehmen Atmosphäre, in der jeder wirklich mitkommt."
  },

  {
    question: "Gibt es getrennte Kurse für Männer und Frauen?",
    answer: "Ja, wir bieten separate Kurse für Männer und Frauen an, um für alle eine angenehme und passende Lernumgebung zu gewährleisten."
  },

  {
    question: "Welche Materialien nutzt ihr?",
    answer: "Je nach Kurs arbeiten wir mit bewährten Lehrmaterialien wie den Madina-Büchern, Arabiyyah Bayna Yadayk sowie weiteren ausgewählten arabischen Lehrtexten. Dazu gehören je nach Niveau auch Werke wie al-Ājurrūmiyya, Qiṣaṣ an-Nabiyyīn und weitere passende Materialien. Die Inhalte werden sorgfältig auf das Niveau und die Lernbedürfnisse der Teilnehmer abgestimmt."
  },

  {
    question: "Was passiert, wenn ich eine Stunde verpasse?",
    answer: "Die Unterrichtseinheiten werden live abgehalten und zusätzlich in hoher Qualität aufgezeichnet. Das bedeutet, dass du verpasste Stunden in Ruhe nachholen oder Inhalte später noch einmal wiederholen kannst."
  },

  {
    question: "Was ist der Schülerbereich?",
    answer: "Der Schülerbereich ist deine persönliche Plattform bei Arabicroots. Dort findest du alle Kursaufzeichnungen, Materialien, deine Fortschrittsanzeige, kommende Live-Termine sowie deine Zertifikate — übersichtlich auf einem Blick, von jedem Gerät aus zugänglich."
  },

  {
    question: "Wann bekomme ich Zugang zum Schülerbereich?",
    answer: "Sobald du dich angemeldet hast und dein Kursplatz bestätigt wurde, erhältst du deine Zugangsdaten per E-Mail und kannst dich direkt einloggen."
  },

  {
    question: "Was ist die Lern-App und was kann sie?",
    answer: "Die Arabicroots Lern-App ist ein Bestandteil deines Kurses. Mit ihr kannst du Vokabeln per Karteikarten üben, Wörter im integrierten Wörterbuch nachschlagen und Verbformen auf einen Blick sehen. Die App ist exklusiv für unsere eingeschriebenen Schüler verfügbar."
  },

  {
    question: "Auf welchen Geräten funktioniert die Lern-App?",
    answer: "Die App ist für iOS und Android verfügbar — du kannst sie also auf deinem Handy oder Tablet nutzen, wann und wo du willst."
  },

  {
    question: "Wie schnell mache ich Fortschritte?",
    answer: "Das hängt von deinem Einsatz und deiner Regelmäßigkeit ab. Durch die klare Struktur und den regelmäßigen Unterricht wirst du jedoch schnell merken, dass du sicherer wirst und echte Fortschritte machst."
  },

  {
    question: "Muss ich Hausaufgaben machen?",
    answer: "Ja, um wirklich Fortschritte zu machen, empfehlen wir regelmäßige Übungen zwischen den Stunden. Diese sind so gestaltet, dass sie dich unterstützen, ohne dich zu überfordern."
  },

  {
    question: "Erhalte ich ein Zertifikat?",
    answer: "Ja, nach erfolgreicher Teilnahme und bestandener Abschlussprüfung erhältst du ein offizielles Zertifikat von Arabicroots."
  },

  {
    question: "Kann ich den Kurs wechseln, pausieren oder kündigen?",
    answer: "Mit deiner Anmeldung wirst du fest in einen Kurs eingeplant, der über einen bestimmten Zeitraum läuft. Während dieses Abschnitts bleibt die Gruppe bewusst stabil, damit alle gemeinsam kontinuierlich Fortschritte machen. Am Ende deiner Laufzeit kannst du entscheiden, ob du den Kurs beendest, auf die nächste Stufe wechselst oder in einen neuen Kurs einsteigst. Für besondere Situationen oder individuelle Anliegen kannst du dich natürlich jederzeit an uns wenden."
  },

  {
    question: "Kann ich außerhalb des Unterrichts Hilfe bekommen?",
    answer: "Ja, du kannst auch außerhalb des Unterrichts Fragen stellen – je nach Anliegen zum Beispiel über WhatsApp, E-Mail oder Instagram."
  }
];
